function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGruppe2969(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Gruppe 2969",
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 159.313,
    viewBox: "0 0 120 159.313",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "j4w5tnoq7a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rechteck 2578",
    style: {
      fill: "none"
    },
    d: "M0 0h120v159.313H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 2968",
    style: {
      clipPath: "url(#j4w5tnoq7a)"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 558",
    cx: 46.077,
    cy: 46.077,
    r: 46.077,
    transform: "rotate(-83.545 60.094 32.129)",
    style: {
      strokeMiterlimit: 10,
      stroke: "#ec1c24",
      strokeWidth: "3.636px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2892",
    d: "M115.021 39.68a4.756 4.756 0 0 0-2.565-6.7l-10.326-3.786a2.471 2.471 0 0 1-1.5-1.586l-3.221-10.519a4.762 4.762 0 0 0-2.609-2.95 4.816 4.816 0 0 0-3.938.029l-9.982 4.626a2.364 2.364 0 0 1-2.179-.06l-9.715-5.161a4.763 4.763 0 0 0-3.931-.24 4.748 4.748 0 0 0-2.764 2.8L58.5 26.466a2.472 2.472 0 0 1-1.585 1.5l-10.522 3.221a4.884 4.884 0 0 0-2.952 2.613 4.761 4.761 0 0 0 .029 3.94l4.627 9.98a2.477 2.477 0 0 1-.058 2.184l-5.161 9.713a4.756 4.756 0 0 0 2.565 6.7L55.768 70.1a2.473 2.473 0 0 1 1.5 1.586L60.489 82.2a4.762 4.762 0 0 0 2.611 2.956 4.822 4.822 0 0 0 3.94-.03l9.98-4.626a2.384 2.384 0 0 1 2.181.059l9.715 5.161a4.751 4.751 0 0 0 3.93.242 4.758 4.758 0 0 0 2.766-2.805L99.4 72.828a2.417 2.417 0 0 1 1.582-1.5l10.518-3.221a4.761 4.761 0 0 0 2.925-6.549l-4.626-9.98a2.477 2.477 0 0 1 .058-2.184z",
    transform: "translate(-6.572 -2.021)",
    style: {
      strokeMiterlimit: 10,
      stroke: "#ec1c24",
      strokeWidth: "3.636px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2893",
    d: "M55.809 162.735a10.153 10.153 0 1 0 10.153 10.153 10.163 10.163 0 0 0-10.153-10.153",
    transform: "translate(-7.09 -25.271)",
    style: {
      fill: "#c5d75d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2894",
    d: "M55.809 162.735a10.153 10.153 0 1 0 10.153 10.153 10.163 10.163 0 0 0-10.153-10.153z",
    transform: "translate(-7.09 -25.271)",
    style: {
      stroke: "#3e4346",
      strokeWidth: "3.649px",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2895",
    d: "M95.9 162.735a10.153 10.153 0 1 0 10.153 10.153A10.164 10.164 0 0 0 95.9 162.735",
    transform: "translate(-13.316 -25.271)",
    style: {
      fill: "#c5d75d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2896",
    d: "M95.9 162.735a10.153 10.153 0 1 0 10.153 10.153A10.164 10.164 0 0 0 95.9 162.735z",
    transform: "translate(-13.316 -25.271)",
    style: {
      stroke: "#3e4346",
      strokeWidth: "3.649px",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2897",
    d: "m112.833 94.628-.006-.006a5.748 5.748 0 0 0-4.3-1.852H30.211L27.2 82.759a5.473 5.473 0 0 0-5.334-3.682H5.529a5.019 5.019 0 1 0 0 9.985H17.64l15.343 51.1a5.477 5.477 0 0 0 5.334 3.679H96.19a5.468 5.468 0 0 0 5.331-3.681l12.339-41.085a4.65 4.65 0 0 0-1.026-4.447",
    transform: "translate(0 -12.28)",
    style: {
      fill: "#3e4346"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2898",
    d: "M113.487 110.21H30.493l6.692 22.29 3.483 11.6a2.433 2.433 0 0 0 2.385 1.484h57.872a2.415 2.415 0 0 0 2.378-1.484l2.972-9.89z",
    transform: "translate(-4.735 -17.114)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2899",
    d: "m111.477 98.756-1.232 4.1H25.4l-4.9-16.309H6.1a2.259 2.259 0 0 1-2.447-1.909A2.233 2.233 0 0 1 6.1 82.727h16.34a2.423 2.423 0 0 1 2.381 1.483l3.666 12.21h80.609a2.7 2.7 0 0 1 2 .824 1.577 1.577 0 0 1 .379 1.511",
    transform: "translate(-.567 -12.846)",
    style: {
      fill: "#c5d75d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2900",
    d: "m86.747 51.673-5.69-.646-3.757 4.321-1.144-5.611-5.271-2.237 4.983-2.822.5-5.7 4.224 3.867 5.579-1.286-2.371 5.205z",
    transform: "translate(-11.007 -6.052)",
    style: {
      fill: "#ec1c24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2901",
    d: "m106.074 44.372-5.69-.646-3.758 4.321-1.144-5.611-5.27-2.236 4.983-2.822.5-5.7 4.224 3.867 5.579-1.286-2.373 5.212z",
    transform: "translate(-14.009 -4.918)",
    style: {
      fill: "#ec1c24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2902",
    d: "m84.311 73.453-5.69-.646-3.758 4.321-1.144-5.611-5.27-2.238 4.983-2.822.5-5.7 4.224 3.867 5.579-1.286-2.373 5.212z",
    transform: "translate(-10.629 -9.434)",
    style: {
      fill: "#ec1c24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2903",
    d: "m103.7 65.656-5.69-.646-3.756 4.32-1.144-5.611-5.27-2.239 4.983-2.822.5-5.7 4.224 3.867 5.579-1.286-2.373 5.212z",
    transform: "translate(-13.64 -8.223)",
    style: {
      fill: "#ec1c24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2904",
    d: "m67.262 58.955-5.69-.646-3.758 4.321-1.144-5.612-5.27-2.239 4.983-2.822.5-5.7 4.224 3.867 5.579-1.286-2.373 5.212z",
    transform: "translate(-7.982 -7.182)",
    style: {
      fill: "#ec1c24"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGruppe2969);
export default __webpack_public_path__ + "static/media/gruppe-2969.baa94290942cb98d17834d9b463eb9b5.svg";
export { ForwardRef as ReactComponent };